import { dsl } from '@wix/yoshi-serverless/wrap';

export const renderModel = dsl({
          functionName: 'renderModel',
          fileName: 'external/feed-page/api/feed.api',
        });